module.exports = __webpack_public_path__ + "img/default-shop-logo.890476d7.png";